import { ActivityEventEnum } from 'types/graphql';
import { BKJThemeColorType } from '@awais4123/fillify-design-library';
import i18next from 'i18next';
import { startCase } from 'utils/startCase';
export interface Activity {
  id: number;
  event: ActivityEventEnum;
  created_at: string;
  feedable: {
    shift_ids: number[];
  };
}

export const auditEvents = (events: string, shift: number) => {
  let details;
  switch (events) {
    case 'accepted':
      details = `${i18next.t('team_member:ACCEPTED_SHIFT')} #${shift}`;
      break;
    case 'assigned':
      details = `${i18next.t('team_member:ASSIGNED_TO_SHIFT')} #${shift}`;
      break;
    case 'acknowledged':
      details = `${i18next.t('team_member:ACKNOWLEDGED_SHIFT')} #${shift}`;
      break;
    case 'cancelled':
      details = `${i18next.t('team_member:SHIFT')} #${shift} ${i18next.t(
        'team_member:WAS_CANCELLED',
      )}`;
      break;
    case 'requested':
      details = `${i18next.t('team_member:REQUESTED_SHIFT')} #${shift}`;
      break;
    case 'declined':
      details = `${i18next.t('team_member:DECLINED_SHIFT')} #${shift}`;
      break;
    case 'auto_released':
      details = `${i18next.t('team_member:REQUEST_AUTOMATICALLY_RELEASED_SHIFT')} #${shift}`;
      break;
    default:
      details = `${startCase(events)} ${i18next.t('team_member:SHIFT')} #${shift}`;
      break;
  }
  return details;
};

export const getActivityColorByEvent = (events: ActivityEventEnum): BKJThemeColorType => {
  switch (events) {
    case 'pending':
      return 'ShiftPending';
    case 'send_to_agencies':
    case 'sent_to_bookjane':
    case 'accepted_by_bookjane':
    case 'created':
    case 'requested':
      return 'ShiftRequested';
    case 'declined':
      return 'SecondaryPendingHover';
    case 'assigned':
      return 'ShiftAssigned';
    case 'accepted':
      return 'AccentGreen';
    case 'cancelled':
      return 'Grey5';
    case 'customer_released':
    case 'jane_released':
    case 'auto_released':
      return 'ShiftRequested';
    default:
      return 'Grey5';
  }
};
